import { Link, useLocation, Navigate, Outlet } from 'react-router-dom'
import {
  Bell,
  BookOpen,
  HelpCircle,
  LogOut,
  MessageCircle,
  MessageSquare,
  Plus,
  Smartphone,
  Tag,
  Users,
} from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { isAuthenticated, logout, getUser } from '@/lib/auth'

export function Layout() {
  const location = useLocation()
  const user = getUser()
  
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />
  }

  const navigation = [
    { name: '图书管理', href: '/', icon: BookOpen },
    { name: '上传新书', href: '/upload', icon: Plus },
    { name: '主题管理', href: '/themes', icon: Tag },
    { name: '用户管理', href: '/users', icon: Users },
    { name: '通知管理', href: '/notifications', icon: Bell },
    { name: '讨论管理', href: '/discussions', icon: MessageCircle },
    { name: '应用版本', href: '/apps/releases', icon: Smartphone },
    { name: '帮助文档', href: '/support/help', icon: HelpCircle },
    { name: '用户反馈', href: '/support/feedback', icon: MessageSquare },
  ]

  const isActive = (href: string) => {
    if (href === '/') {
      return location.pathname === '/'
    }
    return location.pathname.startsWith(href)
  }

  const handleLogout = async () => {
    await logout()
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <div className="fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-sm">
        <div className="flex h-16 items-center justify-between px-6">
          <h1 className="text-xl font-bold text-gray-900">慕途</h1>
        </div>
        
        <nav className="mt-6 px-3">
          <div className="space-y-1">
            {navigation.map((item) => {
              const Icon = item.icon
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`flex items-center rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                    isActive(item.href)
                      ? 'bg-primary-50 text-primary-700'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  }`}
                >
                  <Icon className="mr-3 h-5 w-5" />
                  {item.name}
                </Link>
              )
            })}
          </div>
        </nav>

        {/* User info */}
        <div className="absolute bottom-0 left-0 w-full p-4">
          <div className="flex items-center justify-between rounded-md bg-gray-50 p-3">
            <div className="text-sm">
              <p className="font-medium text-gray-900">{user?.username}</p>
              <p className="text-gray-500">管理员</p>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleLogout}
              className="h-8 w-8 p-0"
            >
              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="ml-64">
        <main className="p-8">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
